<template>  
  <v-app-bar app height="100%"  color="primary" elevate-on-scroll> <!--style="background-color: #F3F5F1;"-->
    <v-container>
      <v-row class="d-flex justify-space-between align-center">
        <v-col sm="4" cols="12" class="d-flex justify-md-start justify-center  pa-0 pa-md-4"> <!-- pb-md-4 pb-0-->
          <span style="" class="fifth--text font-weight-regular display-2">Alex Rogov</span> <!--pb-md-4 pt-md-4 pb-0 pt-10-->
        </v-col>
        <v-col sm="4" cols="12" class="d-flex justify-center pa-0 pa-md-4"> <!--pb-md-0 pt-md-6 pt-0 pb-12--> 
      <v-btn x-large text color="grey darken-4" href="https://www.linkedin.com/in/alex-rogov/" target="_blank" class="title">
        <span>Linkedin</span>
      </v-btn>

      <v-btn x-large text color="grey darken-4" href="https://github.com/rogov-dvp" target="_blank" class="title">
        <span>Github</span>
      </v-btn>

      <!-- <v-btn x-large text color="grey darken-4" href="https://drive.google.com/file/d/1aD_Cb92VwlhzA4iD8VJJ5YiM7KIkaivJ/view?usp=sharing" target="_blank" class="title">
        <span>Resume</span>
      </v-btn> -->
      </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>


export default {
name: "Toolbar",
data(){
  return {
    
  }
}
}
</script>

<style scoped>


</style>